import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-other-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './other-icon.component.html',
  styleUrls: ['./other-icon.component.scss'],
})
export class OtherIconComponent {
  @Input() color!: string;
}
